var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimestamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 13.8H15.7V18.8L19.7 21.2L20.3 20.2L17 18.2V13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9V4C20 2.9 19.1 2 18 2H17V0H15V2H5V0H3V2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H10.7C12.1 24 14.3 25.3 16.9 25.3C21.1 25.3 24.4 21.9 24.4 17.8C24.5 14.7 22.6 12.1 20 10.9ZM2 4H18V7H2V4ZM2 20V9H18V10.4C17.7 10.4 17.3 10.3 16.9 10.3C12.7 10.3 9.4 13.7 9.4 17.8C9.4 18.6 9.5 19.3 9.7 20H2ZM16.9 23.6C13.7 23.6 11.1 21 11.1 17.8C11.1 14.6 13.7 12 16.9 12C20.1 12 22.7 14.6 22.7 17.8C22.8 21 20.2 23.6 16.9 23.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestamp);
export default __webpack_public_path__ + "static/media/timestamp.9dc16abfc0adb16358f8c0fc89ce579a.svg";
export { ForwardRef as ReactComponent };